import { GlassCard, SectionHeader } from "./ui";
import { fmtDate } from "./utils";

export const BirthdaysSection = ({ birthdays, loading }) => {
  const items = Array.isArray(birthdays) ? birthdays : [];
  const today = items.filter((item) => item.isToday);
  const upcoming = items.filter((item) => !item.isToday);

  if (!loading && !items.length) return null;

  return (
    <section id="aniversarios" className="public-section public-birthdays-section py-10 sm:py-12">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader
          k="Comunidade"
          title="Aniversariantes"
          desc="Celebramos com alegria a vida dos nossos irmãos e irmãs."
        />

        {loading ? (
          <div className="public-birthday-grid grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {[0, 1, 2].map((idx) => (
              <GlassCard key={`birthday-skeleton-${idx}`} className="p-5 animate-pulse">
                <div className="flex items-center gap-4">
                  <div className="h-16 w-16 rounded-2xl bg-slate-200 dark:bg-slate-700" />
                  <div className="flex-1"><div className="h-5 w-2/3 rounded bg-slate-200 dark:bg-slate-700 mb-2" /><div className="h-4 w-1/2 rounded bg-slate-200 dark:bg-slate-700" /></div>
                </div>
              </GlassCard>
            ))}
          </div>
        ) : (
          <div className="space-y-6">
            {today.length ? (
              <div>
                <div className="mb-3 text-sm font-bold uppercase tracking-wider text-indigo-700 dark:text-indigo-300">Hoje</div>
                <div className="public-birthday-grid grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                  {today.map((item) => <BirthdayCard key={item.key || item.id} item={item} />)}
                </div>
              </div>
            ) : null}
            {upcoming.length ? (
              <div>
                <div className="mb-3 text-sm font-bold uppercase tracking-wider text-slate-600 dark:text-slate-400">Próximos dias</div>
                <div className="public-birthday-grid grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                  {upcoming.map((item) => <BirthdayCard key={item.key || item.id} item={item} />)}
                </div>
              </div>
            ) : null}
          </div>
        )}
      </div>
    </section>
  );
};

function BirthdayCard({ item }) {
  return (
    <GlassCard className="p-5 hover:shadow-md transition">
      <div className="flex items-center gap-4">
        <div className="h-16 w-16 shrink-0 overflow-hidden rounded-2xl border border-indigo-100 dark:border-indigo-900/50 bg-gradient-to-br from-indigo-100 dark:from-indigo-900/40 to-sky-100 dark:to-sky-900/40 flex items-center justify-center text-2xl">
          {item.photoUrl ? <img src={item.photoUrl} alt={`Foto de ${item.name}`} className="h-full w-full object-cover" loading="lazy" decoding="async" /> : "🎉"}
        </div>
        <div className="min-w-0">
          <div className="font-semibold text-slate-900 dark:text-slate-100 truncate">{item.name}</div>
          {item.role ? <div className="text-sm text-slate-600 dark:text-slate-400 truncate">{item.role}</div> : null}
          <div className="mt-1 text-xs font-semibold text-indigo-700 dark:text-indigo-300">{fmtDate(item.birthdayDate).slice(0, 5)}</div>
        </div>
      </div>
    </GlassCard>
  );
}
